export default __webpack_public_path__ + "static/media/OrewaPain.7ccc61b9.mp3";